import { ConfigProvider, theme } from 'antd';

export const darkblueTheme =
{
    algorithm: theme.darkAlgorithm,
    token: {
        colorPrimary: '#0ea5e9',
        colorSuccess: '#10b981',
        colorWarning: '#f59e0b',
        colorError: '#ef4444',
        colorInfo: '#3b82f6',
        colorTextBase: '#e0f2fe',
        colorBgBase: '#0c1a2e',
        colorPrimaryBg: '#0c2a48',
        colorPrimaryBgHover: '#14406b',
        colorPrimaryBorder: '#1e6091',
        colorPrimaryBorderHover: '#2779bd',
        colorPrimaryHover: '#38bdf8',
        colorPrimaryActive: '#0284c7',
        colorPrimaryText: '#7dd3fc',
        colorPrimaryTextHover: '#bae6fd',
        colorPrimaryTextActive: '#0369a1',
        colorSuccessBg: '#062e22',
        colorSuccessBgHover: '#0c4732',
        colorSuccessBorder: '#10805a',
        colorSuccessBorderHover: '#34d399',
        colorSuccessHover: '#34d399',
        colorSuccessActive: '#059669',
        colorSuccessText: '#34d399',
        colorSuccessTextHover: '#6ee7b7',
        colorSuccessTextActive: '#047857',
        colorWarningBg: '#3a280b',
        colorWarningBgHover: '#573b10',
        colorWarningBorder: '#b47a16',
        colorWarningBorderHover: '#fbbf24',
        colorWarningHover: '#fbbf24',
        colorWarningActive: '#d97706',
        colorWarningText: '#fbbf24',
        colorWarningTextHover: '#fcd34d',
        colorWarningTextActive: '#b45309',
        colorErrorBg: '#3b0f0f',
        colorErrorBgHover: '#5c1919',
        colorErrorBorder: '#c23535',
        colorErrorBorderHover: '#f87171',
        colorErrorHover: '#f87171',
        colorErrorActive: '#dc2626',
        colorErrorText: '#f87171',
        colorErrorTextHover: '#fca5a5',
        colorErrorTextActive: '#b91c1c',
        colorInfoBg: '#0f2447',
        colorInfoBgHover: '#1a3463',
        colorInfoBorder: '#2563eb',
        colorInfoBorderHover: '#60a5fa',
        colorInfoHover: '#60a5fa',
        colorInfoActive: '#1d4ed8',
        colorInfoText: '#60a5fa',
        colorInfoTextHover: '#93c5fd',
        colorInfoTextActive: '#1e40af',
        colorText: 'rgba(224, 242, 254, 0.88)',
        colorTextSecondary: 'rgba(224, 242, 254, 0.65)',
        colorTextTertiary: 'rgba(224, 242, 254, 0.42)',
        colorTextQuaternary: 'rgba(224, 242, 254, 0.22)',
        colorTextDisabled: 'rgba(224, 242, 254, 0.22)',
        colorBgContainer: '#0f2440',
        colorBgElevated: '#142d4d',
        colorBgLayout: '#081526',
        colorBgSpotlight: 'rgba(14, 165, 233, 0.18)',
        colorBgMask: 'rgba(5, 14, 26, 0.72)',
        colorBorder: 'rgba(14, 165, 233, 0.22)',
        colorBorderSecondary: 'rgba(14, 165, 233, 0.12)',
        borderRadius: 8,
        borderRadiusXS: 2,
        borderRadiusSM: 5,
        borderRadiusLG: 12,
        padding: 16,
        paddingSM: 12,
        paddingLG: 24,
        margin: 16,
        marginSM: 12,
        marginLG: 24,
        boxShadow: '0 4px 16px 0 rgba(14, 165, 233, 0.12)',
        boxShadowSecondary: '0 8px 24px 0 rgba(14, 165, 233, 0.18)',
    },
};
